(() => {
  const root = document.querySelector('[data-ms-email-root]');
  if (!root || root.dataset.initialized === 'true') return;
  root.dataset.initialized = 'true';

  const popups = [...root.querySelectorAll('[data-ms-popup]')];
  const overlay = root.querySelector('[data-ms-overlay]');
  const launcher = root.querySelector('.ms-email-launcher');
  const storage = {
    captured: 'msNewsletterCaptured',
    dismissed: 'msNewsletterDismissedAt',
    pending: 'msNewsletterPending',
    session: 'msNewsletterAutoShown',
    bundleQueued: 'msBundlePopupQueued',
    bundleSeen: 'msBundlePopupSeenAt',
    bundleImpressions: 'msBundlePopupImpressions',
    bundlePageCount: 'msBundlePopupPageCount',
    bundleConverted: 'msBundlePopupConverted',
    adventSeen: 'msAdventPopupSeenAt',
    adventConverted: 'msAdventPopupConverted',
  };
  let activePopup = null;
  let productScrollTriggered = false;

  const readStorage = (type, key) => {
    try { return window[type].getItem(key); } catch (_error) { return null; }
  };
  const writeStorage = (type, key, value) => {
    try { window[type].setItem(key, value); } catch (_error) { /* Storage can be unavailable in private contexts. */ }
  };
  const removeStorage = (type, key) => {
    try { window[type].removeItem(key); } catch (_error) { /* Storage can be unavailable in private contexts. */ }
  };

  const getPopup = (name) => root.querySelector(`[data-ms-popup="${name}"]`);
  const isCaptured = () => readStorage('localStorage', storage.captured) === 'true';
  const recentlyDismissed = () => {
    const dismissedAt = Number(readStorage('localStorage', storage.dismissed) || 0);
    return dismissedAt > 0 && Date.now() - dismissedAt < 3 * 24 * 60 * 60 * 1000;
  };
  const bundleCyclePaused = () => {
    const seenAt = Number(readStorage('localStorage', storage.bundleSeen) || 0);
    const storedImpressions = readStorage('localStorage', storage.bundleImpressions);
    if (seenAt > 0 && storedImpressions === null) {
      removeStorage('localStorage', storage.bundleSeen);
      writeStorage('localStorage', storage.bundleImpressions, '0');
      writeStorage('localStorage', storage.bundlePageCount, '0');
      return false;
    }
    if (seenAt > 0 && Date.now() - seenAt < 7 * 24 * 60 * 60 * 1000) return true;
    if (seenAt > 0) {
      removeStorage('localStorage', storage.bundleSeen);
      writeStorage('localStorage', storage.bundleImpressions, '0');
      writeStorage('localStorage', storage.bundlePageCount, '0');
    }
    return false;
  };
  const adventCyclePaused = () => {
    const seenAt = Number(readStorage('localStorage', storage.adventSeen) || 0);
    return seenAt > 0 && Date.now() - seenAt < 7 * 24 * 60 * 60 * 1000;
  };

  const showLauncher = () => {
    if (!isCaptured() && !activePopup) launcher?.classList.add('is-visible');
  };

  const closePopup = ({ remember = true } = {}) => {
    if (!activePopup) return;
    const popupName = activePopup.dataset.msPopup;
    const wasSuccess = activePopup.classList.contains('is-success');
    activePopup.classList.remove('is-open');
    activePopup.setAttribute('aria-hidden', 'true');
    root.classList.remove('has-overlay', 'is-bundle-active', 'is-advent-active');
    document.documentElement.classList.remove('ms-email-scroll-lock');
    if (remember && popupName === 'advent') {
      writeStorage('localStorage', storage.adventSeen, String(Date.now()));
    } else if (remember && popupName === 'bundle') {
      removeStorage('localStorage', storage.bundleQueued);
    } else if (remember) {
      if (!wasSuccess) writeStorage('localStorage', storage.dismissed, String(Date.now()));
      writeStorage('localStorage', storage.bundleQueued, 'true');
    }
    activePopup = null;
    window.setTimeout(showLauncher, 180);
  };

  const openPopup = (name, { success = false, automatic = false, force = false } = {}) => {
    if (isCaptured() && !['advent', 'bundle'].includes(name) && !success && !force) return;
    const popup = getPopup(name) || getPopup('bubble');
    if (!popup) return;
    if (activePopup && activePopup !== popup) closePopup({ remember: false });
    activePopup = popup;
    popup.classList.toggle('is-success', success);
    popup.classList.add('is-open');
    popup.setAttribute('aria-hidden', 'false');
    launcher?.classList.remove('is-visible');
    if (name !== 'bubble') {
      root.classList.add('has-overlay');
      root.classList.toggle('is-bundle-active', name === 'bundle');
      root.classList.toggle('is-advent-active', name === 'advent');
      document.documentElement.classList.add('ms-email-scroll-lock');
    }
    if (automatic && name === 'advent') {
      writeStorage('localStorage', storage.adventSeen, String(Date.now()));
      writeStorage('sessionStorage', storage.session, 'true');
    } else if (automatic && name === 'bundle') {
      const impressions = Number(readStorage('localStorage', storage.bundleImpressions) || 0) + 1;
      writeStorage('localStorage', storage.bundleImpressions, String(impressions));
      writeStorage('localStorage', storage.bundlePageCount, '0');
      removeStorage('localStorage', storage.bundleQueued);
      if (impressions >= 3) writeStorage('localStorage', storage.bundleSeen, String(Date.now()));
    } else if (automatic) {
      writeStorage('sessionStorage', storage.session, 'true');
    }
    window.setTimeout(() => popup.querySelector(success ? '[data-ms-copy-code]' : 'input[type="email"], [data-ms-advent-cta], [data-ms-bundle-cta]')?.focus(), 260);
  };

  root.addEventListener('click', async (event) => {
    const openButton = event.target.closest('[data-ms-open]');
    const closeButton = event.target.closest('[data-ms-close]');
    const copyButton = event.target.closest('[data-ms-copy-code]');
    const bundleCta = event.target.closest('[data-ms-bundle-cta]');
    const adventCta = event.target.closest('[data-ms-advent-cta]');
    if (openButton) openPopup(openButton.dataset.msOpen);
    if (closeButton) closePopup();
    if (event.target === overlay) closePopup();
    if (bundleCta) {
      writeStorage('localStorage', storage.bundleSeen, String(Date.now()));
      writeStorage('localStorage', storage.bundleConverted, 'true');
      removeStorage('localStorage', storage.bundleQueued);
    }
    if (adventCta) {
      writeStorage('localStorage', storage.adventSeen, String(Date.now()));
      writeStorage('localStorage', storage.adventConverted, 'true');
    }
    if (copyButton) {
      const code = root.dataset.coupon;
      try { await navigator.clipboard.writeText(code); } catch (_error) {
        const input = document.createElement('textarea');
        input.value = code;
        document.body.appendChild(input);
        input.select();
        document.execCommand('copy');
        input.remove();
      }
      const label = copyButton.querySelector('[data-ms-copy-label]');
      if (label) label.textContent = 'Copied!';
    }
  });

  root.addEventListener('submit', (event) => {
    const form = event.target.closest('.ms-email-offer__form');
    if (!form) return;
    const source = form.id.replace('ms-email-form-', '');
    writeStorage('localStorage', storage.pending, source);
    const button = form.querySelector('button[type="submit"]');
    button?.classList.add('is-loading');
    if (button) button.textContent = 'Joining…';
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closePopup();
  });

  const params = new URLSearchParams(window.location.search);
  const previewName = params.get('ms_popup_preview');
  const pendingSource = readStorage('localStorage', storage.pending);
  const successfulSource = params.get('ms_newsletter') || (params.has('customer_posted') ? pendingSource : null);
  const adventAvailable = root.dataset.hasAdventProduct === 'true';
  const onAdventProduct = root.dataset.currentProductHandle === 'advent-calendar-2026';
  const adventConverted = readStorage('localStorage', storage.adventConverted) === 'true';
  const adventEligible = adventAvailable && !onAdventProduct && !adventConverted && !adventCyclePaused() && !previewName && !successfulSource;
  if (['welcome', 'drawer', 'bubble', 'advent', 'bundle'].includes(previewName)) {
    openPopup(previewName, { success: params.get('ms_reward') === '1', force: true });
  } else if (successfulSource) {
    writeStorage('localStorage', storage.captured, 'true');
    try { localStorage.removeItem(storage.pending); } catch (_error) { /* No-op. */ }
    openPopup(successfulSource, { success: true });
    if (history.replaceState) history.replaceState({}, '', `${location.pathname}${location.hash || ''}`);
  } else if (adventEligible) {
    window.setTimeout(() => openPopup('advent', { automatic: true }), 1800);
  } else if (!isCaptured()) {
    window.setTimeout(showLauncher, 2600);
    const autoAllowed = !recentlyDismissed() && readStorage('sessionStorage', storage.session) !== 'true';
    if (autoAllowed && root.dataset.pageType === 'index') {
      window.setTimeout(() => openPopup('welcome', { automatic: true }), 6500);
    }
    if (autoAllowed && root.dataset.pageType === 'product') {
      const triggerDrawer = () => {
        if (productScrollTriggered || activePopup || readStorage('sessionStorage', storage.session) === 'true') return;
        productScrollTriggered = true;
        openPopup('drawer', { automatic: true });
      };
      const onScroll = () => {
        const scrollable = document.documentElement.scrollHeight - window.innerHeight;
        if (scrollable > 0 && window.scrollY / scrollable > .28) triggerDrawer();
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      window.setTimeout(triggerDrawer, 12000);
    }
  }

  const bundleAvailable = root.dataset.hasBundleProduct === 'true';
  const onBundleProduct = root.dataset.currentProductHandle === 'dumpling-squishy-mystery-bundle';
  const bundleQueued = readStorage('localStorage', storage.bundleQueued) === 'true';
  const bundleImpressions = Number(readStorage('localStorage', storage.bundleImpressions) || 0);
  const bundleConverted = readStorage('localStorage', storage.bundleConverted) === 'true';
  const bundleEligible = !adventEligible && bundleAvailable && !onBundleProduct && !bundleConverted && !bundleCyclePaused() && bundleImpressions < 3 && !previewName && !successfulSource;
  if (bundleEligible) {
    const bundlePageCount = Number(readStorage('localStorage', storage.bundlePageCount) || 0) + 1;
    writeStorage('localStorage', storage.bundlePageCount, String(bundlePageCount));
    const firstCapturedImpression = isCaptured() && bundleImpressions === 0;
    const dueByPageSpacing = bundleImpressions > 0 && bundlePageCount >= 2;
    if (bundleQueued || firstCapturedImpression || dueByPageSpacing) {
      const tryOpenBundle = (attempt = 0) => {
        if (!activePopup) {
          openPopup('bundle', { automatic: true });
          return;
        }
        if (attempt < 4) window.setTimeout(() => tryOpenBundle(attempt + 1), 3000);
      };
      window.setTimeout(tryOpenBundle, bundleQueued ? 4000 : firstCapturedImpression ? 9000 : 7000);
    }
  }

  const revealTargets = document.querySelectorAll([
    '.ms-collection-card',
    '.ms-product-card',
    '.ms-benefits__grid > *',
    '.ms-story__content',
    '.ms-faq__item',
    '.ms-product-story__card',
    '.ms-product-story__step',
    '.ms-product-story__safe-inner',
  ].join(','));
  if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    const revealVisibleTargets = () => {
      revealTargets.forEach((element) => {
        if (element.classList.contains('ms-soft-reveal--visible')) return;
        const rect = element.getBoundingClientRect();
        if (rect.top < window.innerHeight - 30 && rect.bottom > 0) {
          element.classList.add('ms-soft-reveal--visible');
        }
      });
    };
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('ms-soft-reveal--visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: .12, rootMargin: '0px 0px -30px' });
    revealTargets.forEach((element, index) => {
      element.classList.add('ms-soft-reveal');
      element.style.setProperty('--ms-reveal-delay', `${(index % 4) * 70}ms`);
      observer.observe(element);
    });
    requestAnimationFrame(revealVisibleTargets);
    window.addEventListener('scroll', revealVisibleTargets, { passive: true });
    window.addEventListener('resize', revealVisibleTargets, { passive: true });
  }
})();
